import { AnyUser } from "@megaron/access-control";
import { HttpService } from "@megaron/http-service";
import { HandlerMap } from "@megaron/http-service-host";

import { emailActions } from "./email";
import { imapActions } from "./imap";
import { ticketActions } from "./tickets";

export const supportHttpService = HttpService({
  ...ticketActions,
  ...emailActions,
  ...imapActions,
});

export type SupportHandlers = HandlerMap<typeof supportHttpService, AnyUser>;
